import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Patients } from '@/models/patients';
import { Conclusions } from '@/models/conclusions';

export const MODULE_NAME = Conclusions.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ConclusionsModule extends PageBaseModule {

    constructor(module: ConclusionsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Conclusions.listTitle);
        page.setTitleAdd(Conclusions.createTitle);
        page.values.actionPagination = 'conclusions/updatePage';
        page.values.actionPageAmountItems = 'conclusions/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `patients_${Conclusions.moduleName}_edit`;
        this.pageSettings.routeParam = `${Patients.moduleName}Id`;
        this.pageSettings.routeParamAdditional = `${Conclusions.moduleName}Id`;
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const result = await getList(Conclusions.moduleName, {
                page: this.pageSettings.pageCurrent,
                items: this.pageSettings.pageAmountItems,
            });
            await this.context.dispatch('setList', result.table);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(ConclusionsModule);